import { MHTTPCL, JSON_STRING, HttpClient } from "./http/http-client";
//import {HttpLib} from "../../services/http/http-lib"
import { MEMO_URL } from "./common-urls";
//memos.pl?section=memos&action=total_booking_request_last_seven_days
export const RequestService = {
  getRequestCount: () => MHTTPCL.get(MEMO_URL, {
    section: 'memos',
    action:'total_booking_request_last_seven_days',
    output: JSON_STRING,
  }),
    



}